import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";

const baseUrl = "/api/dog/odbira/odbira";
export const getInsertBySelectionEventById = createAsyncThunk(
  "event/getInsertBySelectionEventById",
  async (eventId, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(`${baseUrl}/${eventId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.message);
    }
  }
);
export const findInsertBySelectionEvent = createAsyncThunk(
  "event/findInsertBySelectionEvent",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        null,
        page,
        filter,
        sort,
        true,
        false
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.message);
    }
  }
);

export const saveAnimalInsertSelectionEvent = createAsyncThunk(
  "event/postAnimalInsertSelectionEvent",
  async (body, { rejectWithValue, fulfillWithValue }) => {
    try {
      if (!body) {
        return rejectWithValue("No body provided");
      }
      const isUpdate = !!body.id || !!body.eventId;
      const id = body.id || body.eventId;
      if (isUpdate) {
        const response = await ApiClient.put(`${baseUrl}/${id}`, body);
        return fulfillWithValue(response.data);
      } else {
        const response = await ApiClient.post(`${baseUrl}`, body);
        return fulfillWithValue(response.data);
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const eventAnimalInsertBySelectionSlice = createSlice({
  name: "eventAnimalInsertBySelectionSlice",
  initialState: {
    byId: {
      data: null,
      isLoading: false,
      error: null,
    },
    page: {},
    eventById: {},
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      saveAnimalInsertSelectionEvent.fulfilled,
      (state, action) => {
        const event = action.payload;
        const { id } = event;
        state.byId[id] = {
          data: event,
          isLoading: false,
          error: null,
        };
      }
    );
    builder.addCase(findInsertBySelectionEvent.fulfilled, (state, action) => {
      const events = action.payload?.content;
      state.page = action.payload;
      for (const event of events) {
        const { id } = event;
        state.byId[id] = {
          data: event,
          isLoading: false,
          error: null,
        };
      }
    });
    builder.addCase(
      getInsertBySelectionEventById.fulfilled,
      (state, action) => {
        const event = action.payload;
        const { id } = event;
        state.eventById[id] = event;

        state.byId[id] = {
          data: { ...event, event: { ...event } },

          isLoading: false,
          error: null,
        };
      }
    );
  },
});

export default eventAnimalInsertBySelectionSlice.reducer;
